import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import FramedTabs from '../components/Homepage/FramedTabs';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { keyframes } from '@emotion/react'; // Import keyframes for animations

// 1. Define the Zoom-In Animation using keyframes
const zoomIn = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.05);
  }
`;

const Homepage_alt = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  // Navigation handlers
  const handleBeginClick = () => {
    navigate('/map');
  };

  const handleLogoClick = () => {
    // navigate('/');
    navigate('/');
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {/* 
        2. Background Image Box:
        - Positioned absolutely to cover the entire viewport.
        - Applied opacity to fade only the background image.
        - Applied the zoom-in animation on mount.
      */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(/images/bg5.jpg)`, // Ensure the path is correct
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          // opacity: 0.1, // Fade effect applied only to the background image
          animation: `${zoomIn} 1s ease forwards`, // Play zoom-in once on load
        }}
      />

      {/* 
        3. Centered Content Container:
        - Positioned relative with higher z-index to stay above the background image.
        - Uses Flexbox to center content both vertically and horizontally.
      */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2, // Ensure content is above the background image
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(2),
        }}
      >
        {/* 
          4. Logo and Title Section:
          - Displays the logo and title side by side.
          - The entire section is clickable via the logo.
        */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(4),
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src="/images/dedalus_logo.png" // Ensure the path is correct
            alt="DEDALUS logo"
            height="50px" // Adjust the height as necessary
            sx={{
              objectFit: 'cover',
              marginRight: theme.spacing(2),
              cursor: 'pointer', // Pointer cursor on hover
            }}
            onClick={handleLogoClick} // Click handler for navigation
          />
          {/* Title Text */}
          <Typography
            variant="h2"
            component="h1"
            fontWeight="bold"
            color="primary"
            noWrap // Prevents text from wrapping
            sx={{
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Adds shadow for readability
              fontSize: {
                xs: '1.5rem', // Small screens
                sm: '2rem',
                md: '3.5rem',
                lg: '5rem',
              },
              lineHeight: 1.2, // Added to improve line height for descenders like 'y'
              marginBottom: theme.spacing(1), // Added to create some space below the text
              paddingBottom: theme.spacing(1), // Added padding to separate text from border
            }}
          >
            Dedalus Flexibility Assessment Tool
          </Typography>
        </Box>

        {/* 
          5. FramedTabs Container:
          - Restricts the width to 70% to prevent it from stretching too wide.
          - Centers the component within the available space.
        */}
        <Box
          sx={{
            width: '100%',
            maxWidth: '50%', // Restrict width to 70%
            marginTop: theme.spacing(2), // Added margin to separate from title
          }}
        >
          <FramedTabs />
        </Box>

        {/* 
          6. BEGIN Button:
          - Positioned below the FramedTabs component.
          - Styled for better visibility and usability.
        */}
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleBeginClick}
          sx={{
            marginTop: theme.spacing(4), // Space above the button
            fontSize: '1.5rem',
            padding: '0.75rem 1.5rem',
            boxShadow: theme.shadows[4], // Adds shadow for depth
          }}
        >
          BEGIN
        </Button>
      </Box>
    </Box>
  );
};

export default Homepage_alt;
